export class ParseHelperUtils {
    static parseToTextHtml(value) {
        const parser = new DOMParser();
        const document = parser.parseFromString(value, 'text/html');
        return document.body.firstChild?.textContent;
    }
}
//# sourceMappingURL=parse-helper-utils.js.map